import React from 'react';
import type { WorkStat } from '../../../types/work';
type VisualStatProps = {
  stat: WorkStat;
  tone: 'light' | 'ink' | 'rust';
  position?: 'top' | 'bottom';
};
const toneClass = {
  light: 'text-white',
  ink: 'text-ink',
  rust: 'text-rust'
};
export function VisualStat({
  stat,
  tone,
  position = 'top'
}: VisualStatProps) {
  return <div className={`absolute left-6 md:left-8 ${position === 'top' ? 'top-5 md:top-7' : 'bottom-5 md:bottom-7'} ${toneClass[tone]}`} data-id="element-428" data-mp="3p176n94wpu2k">
      <p className="text-3xl font-semibold tracking-tight md:text-4xl" data-id="element-429" data-mp="3g09crjo6n2xp">{stat.value}</p>
      <p className={`mt-1 max-w-[180px] text-xs ${tone === 'light' ? 'text-white/75' : 'text-fg-muted'}`} data-id="element-430" data-mp="3b1fwxklfazud">{stat.label}</p>
    </div>;
}